import { yup } from '@framework/validation/initYup.ts';
import { BooleanConditionSchema } from '../../../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema.ts';
import { RichTextAdvancedSchema } from '../../../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';

export const widgetOptionValueValidator = yup
  .object({
    type: yup
      .string()
      .equals(['option'])
      .default('option')
      .required()
      .label('Tipo'),
    label: RichTextAdvancedSchema.label('Etichetta'),
    value: yup
      .string()
      .test({
        name: 'only-allowed-characters',
        message: 'Il valore non può contenere punti',
        test: value => !value?.includes('.'),
      })
      .required()
      .label('Valore'),
    visible: BooleanConditionSchema,
    enabled: BooleanConditionSchema,
  })
  .required()
  .noUnknown();

export const widgetOptionDividerValidator = yup
  .object({
    type: yup
      .string()
      .exact('divider')
      .default('divider')
      .required()
      .label('Tipo'),
    label: RichTextAdvancedSchema.label('Etichetta'),
    visible: BooleanConditionSchema,
  })
  .required()
  .noUnknown();
